import React, { useContext, useEffect, useState, useMemo } from 'react';
import styles from './SubscriptionStatus.module.css';
import { fetchPaymentHistory, fetchSubscriptionUrl } from '../../../services';
import { dataContext } from '../../../App';
import { formatDateTime } from '../../Profile/ReferralHistory/dateFormatter';

const SubscriptionStatus = ({ isSubscribe, isSubscribeMemoryMatch, isSubscribeSpellingBee, setShowLoginModal, setShowOtpModal, setShowRefundModal }) => {
  const { token, playerData } = useContext(dataContext);
  const [wordlyPayment, setWordlyPayment] = useState({});
  const [spellingBeePayment, setSpellingBeePayment] = useState({});
  const [memoryMatchPayment, setMemoryMatchPayment] = useState({});

  useEffect(() => {
    if (token) {
      fetchPaymentHistory(token).then((res) => {
        // Helper to get latest payment by service_type
        function getLatestPayment(serviceType) {
          const filtered = res.filter(
            (item) => item.serviceType === serviceType
          );
          if (filtered.length === 0) return {};
          // Sort by payment_date descending
          filtered.sort(
            (a, b) => new Date(b.paymentDate) - new Date(a.paymentDate)
          );
          return filtered[0];
        }

        setWordlyPayment(getLatestPayment("Wordly"));
        setSpellingBeePayment(getLatestPayment("SpellingBee")); 
        setMemoryMatchPayment(getLatestPayment("MemoryMatch"));
      });
    } else {
      setWordlyPayment({});
      setSpellingBeePayment({});
      setMemoryMatchPayment({});
    }
  }, [token]);

  function handleSubscriptionClick(service_type) {
    if (!playerData?.id) {
      setShowLoginModal(true);
      return;
    }
    fetchSubscriptionUrl(token, service_type)
      .then((res) => {
        setShowOtpModal(true);
      });
  }

  function handleUnSubscriptionClick(service_type) {
    sessionStorage.setItem('unsubsServiceType', service_type);
    setShowRefundModal(true);
  }

  // Create subscription data array
  const subscriptionData = useMemo(() => [
    {
      id: 'wordly',
      type: 'Wordly',
      title: 'WORDLY সাবস্ক্রিপশন',
      background: '#12793C',
      isSubscribed: isSubscribe,
      payment: wordlyPayment,
      feature: 'প্রতিদিন ২ রাউন্ড WORDLY.'
    },
    {
      id: 'memoryMatch',
      type: 'MemoryMatch',
      title: 'MEMORY MATCH সাবস্ক্রিপশন',
      background: '#ff6646',
      isSubscribed: isSubscribeMemoryMatch,
      payment: memoryMatchPayment,
      feature: 'আনলিমিটেড Memory Match রাউন্ড.'
    },
    {
      id: 'spellingBee',
      type: 'SpellingBee',
      title: 'SPELLING BEE সাবস্ক্রিপশন',
      background: '#8700d9',
      isSubscribed: isSubscribeSpellingBee,
      payment: spellingBeePayment,
      feature: 'প্রতিদিন ২ রাউন্ড Spelling Bee.'
    }
  ], [
    isSubscribe, isSubscribeMemoryMatch, isSubscribeSpellingBee,
    wordlyPayment, spellingBeePayment, memoryMatchPayment
  ]);

  // Sort subscriptions: subscribed first, then unsubscribed
  const sortedSubscriptions = useMemo(() =>
    [...subscriptionData].sort((a, b) => {
      if (a.isSubscribed && !b.isSubscribed) return -1;
      if (!a.isSubscribed && b.isSubscribed) return 1;
      return 0;
    }),
  [subscriptionData]);

  return (
    <div className={styles.subscriptionContainer}>
      <h2 className={styles.title}>সাবস্ক্রিপশন</h2>

      {sortedSubscriptions.map((subscription, index) => (
        <div
          key={subscription.id}
          className={styles.subscriptionBox}
          style={index === sortedSubscriptions.length - 1 ? {marginBottom: '0px'} : {}}
        >
          <div className={styles.header}>
            <span className={styles.type} style={{background: subscription.background}}>
              {subscription.title}
            </span>
            {subscription.isSubscribed && <span className={styles.badge}>সাবস্ক্রাইবড</span>}
          </div>

          <div className={styles.price}>
            <span className={styles.amount}>৳৩০</span>
            <span className={styles.duration}>ট্যাক্স সহ ৭ দিনের জন্য</span>
            <br></br><span>**অটো রিনিউয়াল প্রযোজ্য</span>
            {subscription.isSubscribed && subscription.payment?.paymentDate && (
              <>
                <br /><span style={{fontSize:'14px'}}>Payment Date: {formatDateTime(subscription.payment.paymentDate)}</span>
                <br /><span style={{fontSize:'14px'}}>Next Payment Date: {formatDateTime(subscription.payment.nextPaymentDate)}</span>
              </>
            )}
          </div>

          <div className={styles.features}>
            <div className={styles.feature}>{subscription.feature}</div>
          </div>

          {!subscription.isSubscribed && (
            <button
              className={styles.subscribeButton}
              onClick={() => handleSubscriptionClick(subscription.type)}
            >
              সাবস্ক্রাইব করুন
            </button>
          )}

          {subscription.isSubscribed && (
            <button
              className={styles.unsubscribeButton}
              onClick={() => handleUnSubscriptionClick(subscription.type)}
            >
              আনসাবস্ক্রাইব করুন
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default SubscriptionStatus;
